import React from "react";
import type { Tag as TagType } from "./TagInput";
import { Tag, type TagProps } from "./Tag";
import { cn } from "@repo/shared/utils";

export type TagListProps = {
  tags: TagType[];
  customTagRenderer?: (tag: TagType) => React.ReactNode;
  direction?: TagProps["direction"];
} & Omit<TagProps, "tagObj">;

export const TagList: React.FC<TagListProps> = ({
  tags,
  customTagRenderer,
  direction,
  ...tagProps
}) => {
  return (
    <div
      className={cn("rounded-md max-w-[450px]", {
        "flex flex-wrap gap-2": direction === "row",
        "flex flex-col gap-2": direction === "column",
      })}
    >
      {tags.length < 1 && tagProps.disabled && (
        <Tag
          tagObj={{ id: "", text: "<No Tags>" }}
          {...tagProps}
          variant="accent"
        />
      )}
      {tags.map((tagObj, i) =>
        customTagRenderer ? (
          customTagRenderer(tagObj)
        ) : (
          <Tag key={tagObj.id || i} tagObj={tagObj} {...tagProps} />
        )
      )}
    </div>
  );
};
